
import axios from "axios";
import { useAppDispatch, useAppSelector } from "./Hooks/hooks";
import { store } from "./Store/store";
import React, { useEffect, useState, useCallback } from "react";
import { setDocuments } from "./Store/documents/allDocumentsSlice";



const Store = () => {
    const dispatch = useAppDispatch();


    const allDocs = async () => {
        try {
            const res = await axios.post("/DocumentApi/GetDocuments", null);

            dispatch(setDocuments(res.data.UpdatedItem));
            console.log("loadAllUserDocumentsSuccess", res.data.UpdatedItem);
        } catch (err) {
            console.log("loadAllUserDocumentsError", err);
        }
    }

    useEffect(() => { allDocs() }, [])

    return (
        <></>
    )
}

export default Store;